<template>
    <div ref="el" class="button" :class="{'secondary':secondary,'disabled':disabled}" @click="callClick">
        <span :style="{'opacity':loading?'0':'1'}" v-html="label"></span>
        <span v-if="loading" class="button-loader">
            <div class="dot-loader-wrapper">
                <div class="dot-loader"></div>
            </div>
        </span>
    </div>
</template>
<style lang="scss">
    .button-loader{
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .dot-loader-wrapper{
        height: 2rem;
        line-height: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        .dot-loader{
            position: relative;
            width: 10px;
            height: 10px;
            border-radius: 5px;
            background-color: #fff;
            color: #fff;
            animation: dotFlashing 1s infinite linear alternate;
            animation-delay: .5s;
            &::before, &::after {
                content: '';
                display: inline-block;
                position: absolute;
                top: 0;
            }
            &::before {
                left: -15px;
                width: 10px;
                height: 10px;
                border-radius: 5px;
                background-color: #fff;
                color: #fff;
                animation: dotFlashing 1s infinite alternate;
                animation-delay: 0s;
            }
            &::after {
                left: 15px;
                width: 10px;
                height: 10px;
                border-radius: 5px;
                background-color: #fff;
                color: #fff;
                animation: dotFlashing 1s infinite alternate;
                animation-delay: 1s;
            }
        }
    }
    @keyframes dotFlashing {
        0% {
            background-color: #fff;
        }
        50%,100% {
            background-color: #ffa0ab;
        }
    }
</style>
<script>
    export default {
        name:'FieldButton',
        components:{
            
        },
        data:function(){
            return{
            }
        },
        props:{
            label:{
                type:String,
                required:true,
                default:""
            },
            secondary:{
                type:Boolean,
                required:false,
                default:false
            },
            disabled:{
                type:Boolean,
                required:false,
                default:false
            },
            click:{
                type:Function,
                required:false
            },
            loading:{
                type:Boolean,
                required:false,
                default:false
            }
        },
        mounted(){},
        computed:{},
        methods:{
            callClick(){
                if(!this.disabled && !this.loading) this.click.call(this);
            }
        },
    }
</script>